// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class OrderEditUpdateData {
    constructor(dpDict = {}, tradingDataDict = null, sessionSettingsChanged = false, placedFrom = null) {
        this.dpDict = dpDict;
        this.tradingDataDict = tradingDataDict;
        this.sessionSettingsChanged = sessionSettingsChanged;
        this.placedFrom = placedFrom;
    }
    get newTradingDataDict() {
        return this.tradingDataDict;
    }
    get dp() {
        const values = Object.values(this.dpDict);
        return values.length > 0 ? values[0] : null;
    }
}
